export default [
    // {
    //     path: '/collectMoney/topUp',
    //     component: resolve => require(['../topUp.vue'], resolve),
    //     meta: {
    //         title: '会员充值',
    //         keepAlive: false
    //     }
    // },
    // {
    //     path: '/cancelCard',
    //     component: resolve => require(['../cancelCard.vue'], resolve),
    //     meta: {
    //         title: '会员销卡',
    //         keepAlive: false
    //     }
    // }
];